// All editable site content lives here. Phase 2 admin will replace this file.

export const BRAND = {
  name: "Camilla",
  siteTitle: "Camilla XXX",
  handle: "camilla.xxx",
  tagline: "Turkish-Aussie tease. All fun, no judgement.",
  taglineAlt: "Sydney's playful pocket rocket.",
  onlyfans: "https://onlyfans.com/camilla.xxx?rec=485728775",
};

export const CONTACT = {
  phoneDisplay: "0437 780 132",
  phoneIntl: "+61 437 780 132",
  waNumber: "61437780132", // used in wa.me links
};

export const LOCATION = {
  incall: "Liverpool, NSW — private discreet apartment",
  incallShort: "Liverpool incalls",
  outcall: "Sydney metropolitan area",
  outcallShort: "Sydney metro outcalls",
};

export const AVAILABLE_TODAY = true; // Phase 2: admin-toggleable

export const HERO_BLURB =
  "Hi, I'm Camilla — Sydney's Turkish-Aussie pocket rocket. Playful, filthy in the best way, and here to make you forget your day.";

export const ABOUT_ME = [
  "I'm a mid-20s Turkish-Australian girl based in Sydney — petite, tanned, long dark hair, and honestly? A little too much fun. If you're looking for stiff or clinical, keep scrolling. If you want someone who genuinely enjoys this, who'll laugh with you, tease you, and blow your mind — you're in the right place.",
  "My style is genuine GFE with a wild streak. I love the slow build: eye contact, kissing that actually means something, hands wandering, clothes coming off. And I love where it ends up — sweaty, breathless, both of us grinning. I'm judgement-free about your fantasies (bring the weird, I love the weird) and I'm strict about hygiene, discretion and safety. Boundaries are clear, chemistry is real, and every booking is treated like it matters — because it does.",
  "First-timers welcome. Regulars adored. Come as you are — I'll take care of the rest.",
];

export const WHAT_TO_EXPECT = [
  "Discretion: I never discuss clients. Ever. My apartment is private and low-key — you'll walk in like any other visitor.",
  "Hygiene: I shower before every booking; please do the same on arrival (I have everything you need). Fresh sheets, fresh towels, always.",
  "Safety: All full service is with condom. No exceptions. I keep a small first-aid attitude to protection because I like being alive and healthy — and you should too.",
  "Vibe: This isn't a transaction; it's a date with a very naughty twist. Bring your manners, your appetite, and leave the ego at the door.",
];

export const STATS = [
  { label: "Age", value: "Mid-20s" },
  { label: "Nationality", value: "Turkish / Australian" },
  { label: "Height", value: "—" },
  { label: "Hair", value: "Long black" },
  { label: "Eyes", value: "Brown" },
  { label: "Languages", value: "English" },
];

export const PERSONALITY_TAGS = [
  "Playful",
  "Adventurous",
  "Discreet",
  "GFE",
  "No Judgement",
  "Tease",
  "Sensual",
  "Filthy Fun",
];

export const PUBLIC_GALLERY = [
  { src: "/gallery/gallery-01.jpg", alt: "Camilla in red lace" },
  { src: "/gallery/gallery-02.jpg", alt: "Camilla portrait" },
  { src: "/gallery/gallery-03.jpg", alt: "Camilla in strawberry bikini" },
  { src: "/gallery/gallery-04.jpg", alt: "Camilla in black lace bodysuit" },
  { src: "/gallery/gallery-05.jpg", alt: "Camilla in pink lingerie" },
  { src: "/gallery/gallery-06.jpg", alt: "Camilla portrait II" },
];

export const VIP_GALLERY = [
  { src: "/gallery/vip-01.jpg", alt: "VIP 01" },
  { src: "/gallery/vip-02.jpg", alt: "VIP 02" },
  { src: "/gallery/vip-03.jpg", alt: "VIP 03" },
];

export const RATES = [
  { duration: "30 min quickie", incall: "$300", outcall: "$350" },
  { duration: "1 hour", incall: "$500", outcall: "$550", featured: true },
  { duration: "90 minutes", incall: "$700", outcall: "$750" },
  { duration: "2 hours", incall: "$900", outcall: "$950" },
  { duration: "3 hours", incall: "$1,300", outcall: "$1,400" },
  { duration: "Dinner date (3hr + dinner)", incall: "$1,600", outcall: "$1,700" },
  { duration: "Overnight (8hr)", incall: "$2,800", outcall: "$3,000" },
  { duration: "24 hours", incall: "$5,000", outcall: "POA" },
];

export const INCLUDED = [
  "Genuine Girlfriend Experience (GFE)",
  "Deep French kissing (DFK)",
  "Multiple positions",
  "Sensual massage",
  "Oral with condom (BJ)",
  "Cum on body (COB)",
  "Cum on face (COF — on request)",
  "Passionate foreplay",
  "Cuddles & pillow talk",
  "Shower play",
  "Toys (mine or yours — clean)",
  "Role play & fantasy chat",
  "Dirty talk",
  "Tease & striptease",
  "Lingerie of your choice (from my collection)",
  "Light spanking (giving/receiving)",
  "Hair pulling",
  "Mutual massage",
  "Photos of us together (on request, face-blurred)",
];

export const EXTRAS = [
  { name: "Porn Star Experience (PSE)", price: "+$100" },
  { name: "Oral without (OWO)", price: "+$100" },
  { name: "Rimming (giving)", price: "+$150" },
  { name: "Rimming (receiving)", price: "+$100" },
  { name: "Prostate massage", price: "+$100" },
  { name: "Light BDSM / tie & tease", price: "+$150" },
  { name: "Role play with costume (nurse, schoolgirl, secretary, maid — advance)", price: "+$100" },
  { name: "Watersports (giving only)", price: "+$200" },
  { name: "Foot fetish / foot worship", price: "+$50" },
  { name: "Duo with a girlfriend (advance booking)", price: "POA" },
  { name: "Couples (MFM / MFF experience)", price: "+$300" },
  { name: "Fetish-friendly consultations", price: "POA — ask on WhatsApp" },
  { name: "Extended shower/bath together (30 min)", price: "+$100" },
  { name: "Fantasy scripting (send scenario in advance)", price: "+$50" },
  { name: "Same-day booking premium (< 2hr notice)", price: "+$100" },
];

export const NOT_OFFERED = [
  "No unprotected intercourse. No exceptions. All full service is with condom, always.",
  "Nothing illegal. No drugs at bookings. No under-18s discussion.",
  "No greek / anal (currently — may change, ask).",
  "I reserve the right to decline any booking, at any time, for any reason.",
];

export const DEPOSIT = [
  "Bookings under 2 hours: no deposit, cash on arrival.",
  "Bookings 2+ hours or outcalls: 20% deposit via bank transfer to confirm (details sent via WhatsApp).",
  "No-shows blacklisted permanently.",
];

export const FAQS = [
  {
    q: "What's your booking process?",
    a: "Message me on WhatsApp with your name, preferred date/time, duration and whether you'd like an incall (Liverpool) or outcall. I'll confirm availability, take a light screen, and lock it in. Simple.",
  },
  {
    q: "Do you take same-day bookings?",
    a: "Sometimes, yes — if I have a gap. Same-day bookings under 2 hours notice have a +$100 premium. Weekends fill fast, so a day or two ahead is safer.",
  },
  {
    q: "What areas do you cover for outcalls?",
    a: "All of Sydney metro. Within ~20km of the CBD, travel is included in the outcall rate. Further out is POA — just ask.",
  },
  {
    q: "How do I pay?",
    a: "Cash on arrival for anything under 2 hours. For 2+ hours or outcalls, a 20% deposit via bank transfer confirms the booking; balance in cash on the day.",
  },
  {
    q: "What's your screening process?",
    a: "Very light. Your real first name, a working mobile number, and — if you have one — a reference from another Sydney provider makes things instant. I keep all screening info private and delete it after the booking.",
  },
  {
    q: "Are you discreet?",
    a: "Extremely. My apartment is private and low-key, no signage, no drama. I never discuss clients with anyone. Not friends. Not other clients. Ever.",
  },
  {
    q: "What if I'm nervous or a first-timer?",
    a: "Then you're my favourite kind of booking. Tell me it's your first time — I'll take the lead, slow the pace, and make sure you leave with a very silly grin. No judgement.",
  },
  {
    q: "Do you offer duos?",
    a: "Yes — with a girlfriend I trust, advance booking required. Message me on WhatsApp and I'll share options and pricing.",
  },
  {
    q: "What should I bring / how should I prepare?",
    a: "A quick shower before arrival (I have everything you need if you'd rather do it here), mints or a brush of teeth, and cash if applicable. Bring yourself — the real, relaxed version.",
  },
  {
    q: "Can we discuss extras not on the list?",
    a: "Almost always yes. If it's safe, legal and consensual, ask on WhatsApp. I'm judgement-free and open-minded — the worst I'll say is 'not that one, but here's what I can do'.",
  },
];
